import React from 'react';
import { BodyCopy } from '../contentModels/BodyCopy';
import { ColumnBlock } from '../contentModels/ColumnBlock';
import { ContentBlock } from '../contentModels/ContentBlock';
import { ContentBlockGroup } from '../contentModels/ContentBlockGroup';
import { DisclosureLink } from '../contentModels/DisclosureLink';
import { HeyDoctorService } from '../contentModels/HeyDoctorService';
import { HeyDoctorServicesGallery } from '../contentModels/HeyDoctorServicesGallery';
import { ImageBlock } from '../contentModels/ImageBlock';
import { ImageFeature } from '../contentModels/ImageFeature';
import { LayoutBlock } from '../contentModels/LayoutBlock';
import { Link } from '../contentModels/Link';
import { LinkGroup } from '../contentModels/LinkGroup';
import { PageContainer } from '../contentModels/PageContainer';
import { PageHero } from '../contentModels/PageHero';
import { Placeholder } from '../contentModels/Placeholder';
import { QuestionAndAnswerGallery } from '../contentModels/QuestionAndAnswerGallery';
import { Section } from '../contentModels/Section';
import { TextBlock } from '../contentModels/TextBlock';
import { WrapperBlock } from '../contentModels/WrapperBlock';
export const componentMap = {
  BodyCopy: item => /*#__PURE__*/React.createElement(BodyCopy, item),
  XColumnBlock: item => /*#__PURE__*/React.createElement(ColumnBlock, item),
  XContentBlock: item => /*#__PURE__*/React.createElement(ContentBlock, item),
  XContentBlockGroup: item => /*#__PURE__*/React.createElement(ContentBlockGroup, item),
  DisclosureLink: item => /*#__PURE__*/React.createElement(DisclosureLink, item),
  HeyDoctorService: item => /*#__PURE__*/React.createElement(HeyDoctorService, item),
  HeyDoctorServicesGallery: item => /*#__PURE__*/React.createElement(HeyDoctorServicesGallery, item),
  XImageBlock: item => /*#__PURE__*/React.createElement(ImageBlock, item),
  ImageFeature: item => /*#__PURE__*/React.createElement(ImageFeature, item),
  XLayoutBlock: item => /*#__PURE__*/React.createElement(LayoutBlock, item),
  Link: item => /*#__PURE__*/React.createElement(Link, item),
  LinkGroup: item => /*#__PURE__*/React.createElement(LinkGroup, item),
  PageContainer: item => /*#__PURE__*/React.createElement(PageContainer, item),
  PageHero: item => /*#__PURE__*/React.createElement(PageHero, item),
  Placeholder: item => /*#__PURE__*/React.createElement(Placeholder, item),
  QuestionAndAnswerGallery: item => /*#__PURE__*/React.createElement(QuestionAndAnswerGallery, item),
  XSection: item => /*#__PURE__*/React.createElement(Section, item),
  XTextBlock: item => /*#__PURE__*/React.createElement(TextBlock, item),
  XWrapperBlock: item => /*#__PURE__*/React.createElement(WrapperBlock, item)
};